/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-void */
/* eslint-disable no-alert */
import React from "react";

import { Link, useLocation } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import BaseFrame from "../../component/wrapper/BaseFrame";

import { CurriculumInfo } from "../../logic/api/CurriculumInfoService";

const STYLE_ELLIPSIS = { overflow: "hidden", textOverflow: "ellipsis" };

interface LocationState {
    curriculum: CurriculumInfo;
}

const Content = () => {
    // navigate時のState
    const { curriculum = {} as CurriculumInfo } = useLocation().state as LocationState;

    return (
        <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            sx={{
                pt: { xs: 3, sm: 3, md: 8 },
            }}
        >
            <Paper
                sx={{
                    width: "100%",
                    height: "50vh",
                    bgcolor: "white",
                    borderRadius: "15px",
                    padding: 2,
                    mb: 3,
                }}
            >
                <Grid container direction="column" justifyContent="space-around" alignItems="center" flexWrap="nowrap" sx={{ height: "100%" }}>
                    <Grid item>
                        <Typography variant="h1">{"受講取消申請を受け付けました。"}</Typography>
                    </Grid>
                    <Grid item container direction="column" alignItems="center" justifyContent="center" flexWrap="nowrap" rowSpacing={1}>
                        <Grid item sx={{ width: "100%" }} container justifyContent="center">
                            <Typography variant="h5" sx={STYLE_ELLIPSIS}>
                                {curriculum.careerName}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            <Link
                to={`/curriculum/detail/${curriculum.careerId}`}
                style={{
                    textDecoration: "none",
                    color: "inherit",
                    height: "100%",
                    marginBottom: "24px",
                }}
            >
                {"カリキュラム詳細に戻る"}
            </Link>
            <Link to="/home" style={{ textDecoration: "none", color: "inherit", height: "100%" }}>
                {"HOMEへ"}
            </Link>
        </Grid>
    );
};

const CancelAttend = () => <BaseFrame width="70%" content={<Content />} />;

export default CancelAttend;
